class StoresLocator extends HTMLElement {
  constructor() {
    super();
    this.jsonUrl = `/cdn/shop/files/${this.dataset.name}.json?v=${this.dataset.cache}`;
    this.storeFocus = this.querySelector('.store__focus');
    this.storesList = this.querySelector('.stores__list');
    this.searchInput = this.querySelector('.stores__search');
    this.clearInputBtn = this.querySelector('.stores__search-container svg');

    this.getStoresList();
  }

  getStoresList() {
    let stores = [];

    fetch(this.jsonUrl)
      .then(response => response.json())
      .then(json => {stores = json})
      .then(() => {
        this.createMap(stores);
        this.createList(stores);
      })
  }

  createMap(stores) {
    const map = new maplibregl.Map({
      container: 'storesMap',
      style: `https://maps.geoapify.com/v1/styles/positron/style.json?apiKey=${GEO_APIFY_KEY}`,
      center: [2.214, 46.228], // [lng, lat]
      zoom: 4.75, // starting zoom
    });

    // map.setLayoutProperty('your-layer-id', 'visibility', 'none');
    map.addControl(new maplibregl.NavigationControl());

    stores.forEach(store => {
      const mkr = document.createElement('div');
      mkr.id = `mkr-${store.id}`;
      mkr.className = 'store-marker';
      mkr.innerHTML = window.icons.favicon;
      mkr.addEventListener('click', () => {
        map.flyTo({
          center: [store.lng, store.lat],
          zoom: 12,
          essential: true
        });
      });
      mkr.addEventListener('mouseenter', () => this.focusStore(store, 'hover'));

      const marker = new maplibregl.Marker({ element: mkr })
        .setLngLat([store.lng, store.lat])
        .addTo(map);
    });
  }

  createList(stores) {
    stores.forEach(store => {
      const li = document.createElement('li');
      li.innerHTML = `<h3 class="store__name">${store.name}</h3><p class="store__address">${store.address}</p><p class="store__city"><small>${store.zip}</small> ${store.city}</p>`;
      li.addEventListener('click', () => this.focusStore(store, 'click'));
      this.storesList.appendChild(li);
    });

    this.searchStores();
  }

  focusStore(store, event) {
    const marker = document.getElementById(`mkr-${store.id}`);

    this.storeFocus.innerHTML = `<h3>${store.name}</h3><p>${store.address}</p><p>${store.zip} ${store.city}</p>`;
    document.querySelectorAll('.store-marker').forEach(mkr => mkr.classList.remove('active'));
    setTimeout(() => {
      marker.classList.add('active');
    }, 10);
    event == 'click' && marker.click();
  }

  searchStores() {
    this.searchInput.addEventListener('keyup', () => {
      const searchValue = this.searchInput.value.toLowerCase(),
            storeItems = this.storesList.querySelectorAll('li');

      console.log('searching for', searchValue);
      storeItems.forEach(item => {
        const storeName = item.querySelector('.store__name').textContent.toLowerCase(),
              storeAddress = item.querySelector('.store__address').textContent.toLowerCase(),
              storeCity = item.querySelector('.store__city').textContent.toLowerCase();

        if (storeName.includes(searchValue) || storeAddress.includes(searchValue) || storeCity.includes(searchValue)) {
          item.style.display = 'flex';
        } else {
          item.style.display = 'none';
        }
      });
    });

    this.clearInputBtn.addEventListener('click', () => {
      this.searchInput.value = '';
      this.searchInput.dispatchEvent(new Event('keyup'));
    });
  }
}

customElements.define('stores-locator', StoresLocator);
